import React from 'react';
import FilterToggles from '@/components/buttons/FilterToggles';
import { approvalStatus } from '../constants';

const RequestsFilterToggles = ({
  pendingFlag,
  approvedFlag,
  deniedFlag,
  errorFlag,
  showErrors,
  updateFlags,
}) => (
  <FilterToggles filters={[
    {
      active: pendingFlag,
      icon: 'clock',
      key: 'requests_pending',
      messageId: `requests.status.filter.${approvalStatus.PENDING}`,
      onClick: () => updateFlags({
        pendingFlag: !pendingFlag, approvedFlag, deniedFlag, errorFlag,
      }),
    },
    {
      active: approvedFlag,
      icon: 'thumbs up',
      key: 'requests_approved',
      messageId: `requests.status.filter.${approvalStatus.APPROVE}`,
      onClick: () => updateFlags({
        pendingFlag, approvedFlag: !approvedFlag, deniedFlag, errorFlag,
      }),
    },
    {
      active: deniedFlag,
      icon: 'thumbs down',
      key: 'requests_denied',
      messageId: `requests.status.filter.${approvalStatus.DENY}`,
      onClick: () => updateFlags({
        pendingFlag, approvedFlag, deniedFlag: !deniedFlag, errorFlag,
      }),
    },
    ...(showErrors
      ? [{
        active: errorFlag,
        icon: 'times circle',
        key: 'requests_errored',
        messageId: `requests.status.filter.${approvalStatus.ERROR}`,
        onClick: () => updateFlags({
          pendingFlag, approvedFlag, deniedFlag, errorFlag: !errorFlag,
        }),
      }]
      : []),
  ]}
  />
);

export default RequestsFilterToggles;
